import { BsArrowRight } from "react-icons/bs";

const OdooPOPreview = ({
  orderId,
  orderNumber,
  orderTotal,
  orderLines = [],
  compareOdoo,
}) => {
  console.log("OdooPOPreview.orderLines", orderLines);

  return (
    <div className=" space-y-4">
      {orderId && orderNumber && (
        <h5 className="mb-2">
          {orderId} - {orderNumber}
        </h5>
      )}

      <div className="-mx-2">
        <table>
          <thead>
            <tr className="whitespace-nowrap">
              <th>Item</th>
              <th className="text-right">Unit Price</th>
              <th className="text-right">Quantity</th>
              <th className="text-right">Total</th>
            </tr>
          </thead>
          <tbody>
            {orderLines.map((line) => (
              <tr
                key={line.id}
                className={`border-y border-gray-100 dark:border-gray-700
                  ${
                    compareOdoo && line.odooQty !== line.qty
                      ? "text-red-600"
                      : ""
                  }
                  `}
              >
                <td>{line.name}</td>
                <td className="text-right">{line.salesPrice?.toFixed(2)}</td>
                <td className="text-right">
                  {compareOdoo ? (
                    <div className="flex justify-end items-center space-x-2 whitespace-nowrap">
                      <span>{line.odooQty}</span>
                      <BsArrowRight />
                      <span>{line.qty}</span>
                    </div>
                  ) : (
                    line.qty
                  )}
                </td>
                <td className="text-right">{line.totalPrice?.toFixed(2)}</td>
              </tr>
            ))}
          </tbody>
          {orderTotal > 0 && (
            <tfoot>
              <tr className="font-semibold">
                <td>Total</td>
                <td></td>
                <td></td>
                {!compareOdoo && (
                  <td className="text-right">{orderTotal.toFixed(2)}</td>
                )}
              </tr>
            </tfoot>
          )}
        </table>
      </div>
    </div>
  );
};

export default OdooPOPreview;
